/**
 * Consecutive `tool_call_start`s that overlap — a start arrives while another
 * tool on the same plan step is still `running` — share a batch id. That is
 * the parallel execution group. A start after every peer has completed
 * opens a new batch (serial follow-up, or the next assistant turn).
 *
 * Overlap is the only live signal available: the wire carries no assistant-turn
 * boundary. So a turn wider than the executor's concurrency cap shows up as
 * more than one group while streaming. Reloading the conversation regroups by
 * assistant message, which is exact.
 */
export interface LiveBatchPeer {
  parentStepIndex: number
  status: string
  batchId?: string
}

export function nextLiveToolBatchId(
  existing: readonly LiveBatchPeer[],
  parentStepIndex: number,
  allocate: () => string
): string {
  const peer = existing.find(
    (tc) =>
      tc.parentStepIndex === parentStepIndex &&
      tc.status === 'running' &&
      typeof tc.batchId === 'string' &&
      tc.batchId.length > 0
  )
  return peer?.batchId ?? allocate()
}
